import {GenEventResultItem} from '../../../../../generated/serverModels/GenEventResultItem';
import {IGeometry} from '../../../classes/application-config';
import {HeadoutTableData} from '../interfaces/headout-table-data.interface';

export class HeadoutEventResultItem extends GenEventResultItem {
    static ConvertToReportData(detail: HeadoutEventResultItem): HeadoutTableData {
        return {
            state: detail.stateName,
            county: detail.countyName,
            customersOut: (detail.outagePercentage / 100) * detail.customers,
            totalCustomers: detail.customers,
            percentOut: detail.percent,
        };
    }
    county: IGeometry;
    countyName: string;
    stateName: string;
}
